import { createGlobalStyle } from 'styled-components';
import reboot from 'styled-reboot';

const rebootCss = reboot();

export default createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;700;900&family=Ubuntu:wght@300;400&display=swap');
  ${rebootCss}

  @import url('https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.css');
  @import url('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.7.3/mapbox-gl-geocoder.css');

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  h2 {
    margin-bottom: 25px;
  }

  #map-wrap {
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    height: 450px;
    border: 1px solid #ebeaea;
  }

  @media(max-width: 500px) {
    #map-wrap {
      height: 400px;
    }
  }

  .mapContainer {
    width: 100%;
    height: 100%;
  }

  .mid-col {
    width: 100%;
    max-width: 960px;
    position: relative;
    margin: 20px auto;
  }

  .content-wrap {
    position: relative;
    margin: 10px auto;
    width: 100%;
    max-width: 960px;
    padding: 0;
  }

  .chart-wrap {
    position: relative;
  }

  /*
  table {
    width: 100%;
  }

  th {
    padding: 5px 5px 5px 5px;
    background-color: black;
    color: white;
  }

  td {
    padding: 5px 5px 5px 5px;
  }

  .tVotes, .tPerc {
    text-align: center;
    font-family: 'Ubuntu';
    font-size: 15px;
    font-weight: 400;
  }

  .tParty {
    text-transform: capitalize;
  }

  tr:nth-child(odd) {
    background-color: #dfdfdf;
  }
  */

  .row-wrap {
    display: flex;
  }

  .row-wrap.head {
    background-color: black;
    color: white;
  }

  .row-wrap.bar {
    background-color: #f4f4f4;
  }

  .tVotes, .tPerc {
    text-align: right;
    font-family: 'Ubuntu';
    font-size: 15px;
    line-height: 18px;
    font-weight: 400;
    width: 20%;
    padding: 10px 10px 0 10px;
  }

  .tVotes.head {
    padding: 10px;
  }

  @media(max-width: 650px) {
    .tVotes, .tPerc {
      width: 25%;
      font-size: 12px;
      line-height: 15px;
    }
  }

  .tParty {
    width: 59.9%;
    padding: 4px 10px;
    font-family: 'Ubuntu';
    font-weight: 500;
    font-size: 15px;
    padding: 10px 10px 0 10px;
  }

  @media(max-width: 650px) {
    .tParty {
      width: 49.9%;
      font-size: 12px;
      line-height: 15px;
    }
  }

  .source {
    font-size: 13px;
    line-height: 19px;
    min-height: 100px;
  }
`;
